import $ from "jquery";

const utilities = {
  uuidv4: function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },

  getStates: function() {
    return this.$store.getters
      .fetcher({
        query: `{
          GetAllStates {
            State_Id
            Name
          }
        }`
      })
      .then(res => res.data.GetAllStates);
  },

  showSnackbar: function(text, longshow) {
    var snackbar = document.getElementById("snackbar");
    snackbar.innerHTML = text;
    if (longshow) {
      snackbar.className = "long-show";
      setTimeout(
        () =>
          (snackbar.className = snackbar.className.replace("long-show", "")),
        6000
      );
    } else {
      snackbar.className = "show";
      setTimeout(
        () => (snackbar.className = snackbar.className.replace("show", "")),
        3000
      );
    }
  },

  dateToYYYYMMDD(d) {
    return (
      d &&
      new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000)
        .toISOString()
        .split("T")[0]
    );
  },

  updateToggleIcon: function(iconId) {
    var icon = $(iconId);
    if (icon.text() == "add") {
      icon.text("remove");
    } else {
      icon.text("add");
    }
  },

  orderByName: function(a, b) {
    var textA = a.Name.toUpperCase();
    var textB = b.Name.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByParseName: function(a, b) {
    var textA = a.get("name").toUpperCase();
    var textB = b.get("name").toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByParseOrder: function(a, b) {
    var orderA = a.get("order");
    var orderB = b.get("order");
    return orderA < orderB ? -1 : orderA > orderB ? 1 : 0;
  },

  orderByTitle: function(a, b) {
    var textA = a.Title.toUpperCase();
    var textB = b.Title.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByOrder: function(a, b) {
    var orderA = a.Order;
    var orderB = b.Order;
    return orderA < orderB ? -1 : orderA > orderB ? 1 : 0;
  },

  orderByLastName: function(a, b) {
    var textA = a.Last_Name.toUpperCase();
    var textB = b.Last_Name.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByUnitTitle: function(a, b) {
    var textA = a.Unit.Title.toUpperCase();
    var textB = b.Unit.Title.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByDate: function(a, b) {
    var textA = a.Date;
    var textB = b.Date;
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  rangeArray: function(start, stop, step) {
    var a = [parseInt(start)],
      b = parseInt(start);
    while (b < parseInt(stop)) {
      a.push((b += step || 1));
    }
    return a;
  },

  tryParse: function(input) {
    try {
      return JSON.parse(input);
    } catch (e) {
      return undefined;
    }
  },

  onlyUnique: function(value, index, self) {
    return self.indexOf(value) === index;
  },

  onlyUniqueStudentIds: function(value, index, self) {
    return self.findIndex(s => s.Student_Id == value.Student_Id) === index;
  },

  showTooltip: function(id) {
    $(id).tooltip("show");
  },
  hideTooltip: function(id) {
    $(id).tooltip("hide");
  }
};

export { utilities };
